import { Component, OnInit } from '@angular/core';

import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';
import 'leaflet-draw';
declare const L: any;

interface KeyValue {
  key: string;
  value: string;
  keyValue?: KeyValue[];
}

interface NameValue {
  key: string;
  value: string;
  boxType: string;
  isMandatory: boolean;
  keyValue?: NameValue[] | string[];
}
@Component({
  selector: 'app-asset-buld',
  templateUrl: './asset-buld.component.html',
  styleUrls: ['./asset-buld.component.css']
})
export class AssetBuldComponent implements OnInit {

  private drawControl: any;
  constructor(private fb: FormBuilder, private toastr: ToastrService, private generic_service: GenericService) { }

  getObjectInfoById(list: any, index: any) {
    this.singleObjectInfoData = []
    this.singleObjectInfoData.push(list)
  }

  objectInfoList: any = []


  objectInfoList1: any = []
  objectInfoList2: any = []
  failedObjectInfoList: any = []
  isFailedObject: any = false
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  first: number = 0;
  tableSizes: any = [3, 6, 9, 12];

  page2: number = 1;
  count2: number = 0;
  tableSize2: number = 10;
  first2: number = 0;
  tableSizes2: any = [3, 6, 9, 12];

  page3: number = 1;
  count3: number = 0;
  tableSize3: number = 10;
  first3: number = 0;
  tableSizes3: any = [3, 6, 9, 12];

  isLoading: any = false
  singleObjectInfoData: any = []
  cid: any
  isExcel: any = false

  // Map variables
  isMapView: boolean = false;
  isFullscreen: boolean = false;
  private map!: L.Map;
  private markers: any[] = [];
  private defaultCenter: any = [17.4065, 78.4772];
  private defaultZoom: any = 10;

  locationList: any = []
  locationFilterList: any = []
  userCred: any;
  userLocations: any = []

  ngOnInit(): void {
    this.cid = Number(sessionStorage.getItem('cid'))
    this.userCred = JSON.parse(sessionStorage.getItem('userCreds')!);
    this.getAllLocation()
  }

  getAllLocation() {
    this.generic_service.getAllLocation().subscribe(
      (res: any) => {
        this.locationList = res.response

        this.locationFilterList = (this.locationList?.filter((location: any) =>
          this.userCred?.locations?.includes(location.locationId)
        )) || [];
        console.log(this.locationFilterList)

        this.userLocations = this.locationFilterList.map((item: any) => item.zone);
        console.log(this.userLocations)
      },
      (err: any) => {
        console.log(err)
      }
    )
  }

  onTableDataChange(event: any) {
    console.log(event)
    this.page = event.page + 1;
  }

  onTableDataChange2(event: any) {
    console.log(event)
    this.page2 = event.page + 1;
  }

  onTableDataChange3(event: any) {
    console.log(event)
    this.page3 = event.page + 1;
  }

  change(item: any) {
    item.isSubmit = false
  }

  separateObjectsByGivenName() {

    for (let i = 0; i < this.objectInfoList.length; i++) {
      this.objectInfoList[i].id = i + 1;
      this.objectInfoList[i].isSubmit = true;
    }

    const givenNameCount: { [key: string]: number } = {};

    // Count occurrences of each givenName
    this.objectInfoList.forEach((item: any) => {
      givenNameCount[item.givenName] = (givenNameCount[item.givenName] || 0) + 1;
    });

    console.log(givenNameCount)

    // Separate into objectInfoList1 (unique) and objectInfoList2 (duplicates)
    this.objectInfoList1 = this.objectInfoList.filter((item: any) => givenNameCount[item.givenName] === 1);
    this.objectInfoList2 = this.objectInfoList.filter((item: any) => givenNameCount[item.givenName] > 1);

    console.log(this.objectInfoList1)
    console.log(this.objectInfoList2)


    this.assetNames = []
    for (let list of this.objectInfoList1) {
      this.assetNames.push(list.givenName)
    }
    this.checkAllByNameAndCid(this.assetNames)

  }

  addAssetClick() {
    document.getElementById("add-btn")?.click()
  }

  removeRecord(id: any) {
    console.log(id)
    for (let i = 0; i < this.objectInfoList1.length; i++) {
      if (this.objectInfoList1[i].id === id) {
        this.objectInfoList1.splice(i, 1);
        console.log('ok')
        break; // Stop after removing one item
      }
    }
  }

  refresh() {
    this.isExcel = false
    const fileInput = document.getElementById("add-btn") as HTMLInputElement;
    if (fileInput) {
      fileInput.value = ''; // Reset the input value
    }
    this.assetNames = []
    this.objectInfoList = []
    this.objectInfoList1 = []
    this.objectInfoList2 = []
    this.isFailedObject = false
    this.failedObjectInfoList = []
    this.isExcel = false
  }


  bulkData: any = []

  onExcelFileChange(event: any, excelFileInput: HTMLInputElement): void {
    const target: DataTransfer = <DataTransfer>(event.target);

    if (target.files.length !== 1) {
      console.error('Please upload a single file.');
      this.isExcel = false;
      return;
    }

    const file = target.files[0];

    // Extract template ID from file name
    const fileNameMatch = file.name.match(/_(\d+)_/); // e.g., name_template_123_.xlsx
    let templateId: number;

    if (fileNameMatch) {
      templateId = parseInt(fileNameMatch[1], 10);
    } else {
      console.error('No valid template ID found in file name.');
      excelFileInput.value = '';
      this.isExcel = false;
      return;
    }

    const reader: FileReader = new FileReader();

    reader.onload = (e: any) => {
      const binaryStr: string = e.target.result;
      const workbook: XLSX.WorkBook = XLSX.read(binaryStr, { type: 'binary' });

      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const rawData: any[] = XLSX.utils.sheet_to_json(worksheet, { defval: '' });

      console.log('Parsed Excel Data:', rawData);

      if (rawData.length >= 100) {
        this.toastr.error('File contains too many rows. Maximum allowed is 100.');
        excelFileInput.value = '';
        return;
      }

      // Map of Excel labels to internal keys
      const labelToKeyMap: any = {
        'Acquisition Date': 'acquisitionDate',
        'Asset Life Number': 'assetLifeNumber',
        'Lat': 'lat',
        'Lng': 'lng',
        'Category': 'asset_Category',
        'Serial Number': 'serialNumber',
        'Branch': 'branch',
        'Department': 'department',
        'Location': 'location',
        'Make': 'make',
        'Model': 'model',
        'Original Cost': 'originalCost',
        'Current Cost': 'currentCost',
        'Salvage Value': 'salvageValue',
        'Depreciation Method': 'depreciationMethod',
        "Name": 'givenName',
        "Condition": 'objectCondition',
        'MultiLatLng': 'multiLatLng',
        'Area': 'area',
      };

      // Convert label-based keys to internal keys
      const mappedData = rawData.map((row: any) => {
        const newRow: any = {};

        for (const label in row) {
          const internalKey = labelToKeyMap[label];
          if (internalKey) {
            newRow[internalKey] = row[label];
          }
        }

        const parsedLat = parseFloat(newRow['lat']);
        const parsedLng = parseFloat(newRow['lng']);
        newRow['lat'] = isNaN(parsedLat) ? null : parsedLat;
        newRow['lng'] = isNaN(parsedLng) ? null : parsedLng;
        newRow['selected'] = false;
        newRow['multiLatLng'] = newRow['multiLatLng'] === true || newRow['multiLatLng'] === 'true' || newRow['multiLatLng'] === 'TRUE';

        let area = null;
        if (newRow['area']) {
          try {
            area = typeof newRow['area'] === 'string' ? JSON.parse(newRow['area']) : newRow['area'];
          } catch (e) {
            console.error("Error parsing area", e);
          }
        }
        newRow['area'] = area;

        return newRow;
      });

      console.log(mappedData)

      let isConditionGood = true;
      for (let data of mappedData) {
        if (data.objectCondition !== 'Good') {
          console.log(data)
          isConditionGood = false;
          break;
        }
      }

      if (!isConditionGood) {
        this.toastr.error('All assets must have condition as Good');
        excelFileInput.value = '';
        this.isExcel = false;
        return;
      }

      let isLocationPresent = true;
      for (let data of mappedData) {
        if (!data.location || String(data.location).trim() === '') {
          isLocationPresent = false;
          break;
        }
      }

      if (!isLocationPresent) {
        this.toastr.error('All assets must have a location');
        excelFileInput.value = '';
        this.isExcel = false;
        return;
      }

      for (let data of mappedData) {
        if (!this.userLocations.includes(data.location)) {
          this.toastr.error(`Location Do Not Exist : ${data.location}, Asset Name : ${data.givenName}, Please check spelling or spaces`);
          excelFileInput.value = '';
          this.isExcel = false;
          return;
        }
      }
      console.log(mappedData)


      // Fetch the template and enrich each row
      this.generic_service.getObjectTemplateById(templateId).subscribe(
        (res: any) => {
          console.log(res)

          for (let list of mappedData) {

            console.log(list)

            let loc: any
            for (let location of this.locationList) {
              if (location.zone == list.location) {
                console.log(location)
                loc = location
              }
            }


            // Map template metadata
            list.branchCheckBox = res.response.branch || false;
            list.departmentCheckBox = res.response.department || false;
            list.locationCheckBox = res.response.location || false;
            list.makeCheckBox = res.response.make || false;
            list.modelCheckBox = res.response.model || false;
            list.originalCostCheckBox = res.response.originalCost || false;
            list.currentCostCheckBox = res.response.currentCost || false;
            list.serialNumberCheckBox = res.response.serialNumber || false;
            list.depreciationCheckbox = res.response.depreciationRequired || false;
            list.deploy = res.response.deploy || false;
            // Static metadata
            list.name = res.response.name || '';
            list.type = res.response.type || '';
            list.group = res.response.group || '';
            list.branchId = 0;
            list.images = [];
            list.tags = [];
            list.assetMonitoring = false;
            list.multiLatLng = list.multiLatLng || false;
            list.assetMonitoringFrequency = 0;
            list.assetMonitoringTimeSpan = 0;
            list.subGroups = [];
            list.nameValue = [];
            list.connectionDetails = [];
            list.assetHealth = [];
            list.performanceMatrix = [];
            list.cid = Number(this.cid);
            list.alive = false;
            list.area = list.area || [];
            list.description = "bulk";
            list.version = 0;
            list.isActive = true;
            list.objectInfoId = 0;
            list.layerInfoId = 0;
            list.conditionModifiedBy = [];
            list.approvalInfos = [];
            list.icon = res.response.iconUrl || '';
            list.objectStatus = "";
            list.objStatus = [];
            list.objectStatusColor = "";
            list.objectColorCode = "";
            list.depreciationMethodName = "";
            list.country = loc.country;
            list.provinceOrState = loc.provinceOrState;
            list.snmpMonitoringId = "";
            list.district = loc.district;
            list.zone = list.location;
            list.postalCode = loc.postalCode;
            list.city = loc.city;

            list.stockPointStatus = loc.stockPoint || false;
            list.stockPointId = loc.locationId || 0;
            list.stockPointName = loc.zone || ""

            list.allocationId = [];
            list.latestAllocationId = 0;
            list.parentAssetId = [];
            list.childAssetId = [];
            list.putToUseDate = "";
            list.assetStatus = "";
            list.imagesWithDetails = [];
            list.level = 0;
            list.deployCurrentLocation = false;
            list.repairInfos = [];
            list.givenRepair = false;
            list.available = true;
            list.purchaseInfo = [];
            list.warrantyInfo = [];
            list.holding = [
              {
                "allocationRegisterId": 0,
                "userId": 0,
                "name": "COMPANY",
                "date": new Date().getTime()
              }
            ];
            list.latestHolding = {
              "allocationRegisterId": 0,
              "userId": 0,
              "name": "COMPANY",
              "date": new Date().getTime()
            };
          }

          this.bulkData = mappedData;
          this.objectInfoList = mappedData;
          console.log(this.objectInfoList)
          this.separateObjectsByGivenName(); // Assuming this categorizes rows
          console.log('Final Imported Data:', this.bulkData);
        },
        error => {
          console.error('Template fetch failed:', error);
          this.toastr.error('Failed to load template. Please try again.');
        }
      );
    };

    reader.readAsBinaryString(file);
  }


  assetNames: any = []
  checkAllByNameAndCid(assetNames: any) {
    let body = {
      assetNames: assetNames,
      cid: this.cid
    };

    console.log(body);

    this.generic_service.checkAllByNameAndCid(body).subscribe(
      (response: any) => {
        console.log(response);

        if (response.response && response.response != null) {
          let nameList = this.objectInfoList1.filter((item: any) =>
            response.response.includes(item.givenName)
          );
          console.log('Matched Items:', nameList);

          for (let list of nameList) {
            this.objectInfoList2.push(list);
          }

          let objectInfoList = this.objectInfoList1.filter((item: any) =>
            !response.response.includes(item.givenName)
          );
          console.log('Unmatched Items:', objectInfoList);
          this.objectInfoList1 = objectInfoList
        }

        this.count = this.objectInfoList1.length;
        this.count2 = this.objectInfoList2.length;

        this.isExcel = true
      },
      (error: any) => {
        console.log(error);
      }
    );
  }


  insertMultipleObjectInfos() {
    if (!this.isExcel) {
      return
    }

    let isConditionGood = true;
    for (let list of this.objectInfoList1) {
      if (list.objectCondition !== 'Good') {
        isConditionGood = false;
        break;
      }
    }

    if (!isConditionGood) {
      this.toastr.error('All objects must have objectCondition as Good');
      return;
    }

    let isLocationPresent = true;
    for (let list of this.objectInfoList1) {
      if (!list.location || String(list.location).trim() === '') {
        isLocationPresent = false;
        break;
      }
    }

    if (!isLocationPresent) {
      this.toastr.error('All objects must have a location');
      return;
    }

    for (let list of this.objectInfoList1) {
      delete list.id;
      if (list.acquisitionDate) {
        const date = new Date(list.acquisitionDate);
        if (!isNaN(date.getTime())) {
          list.acquisitionDate = date.getTime();
        }
      }
    }
    console.log(this.objectInfoList1)
    this.generic_service.insertMultipleObjectInfos(this.objectInfoList1).subscribe(
      (response: any) => {
        console.log(response)
        this.toastr.success(response.message);
        if (response.response && response.response.length != 0) {
          this.isFailedObject = true
          for (let list of response.response) {
            list.failedObjectInfoList.error = list.errorMessage
            this.failedObjectInfoList.push(list.failedObjectInfoList)
          }

          this.count3 = this.failedObjectInfoList.length
        } else {
          this.refresh()
        }

        console.log(this.failedObjectInfoList)

        this.isExcel = false

      },
      (error: any) => {
        console.log(error)
        this.toastr.error(error.error.errors[0].description);

      }
    )
  }

  toggleMapView(isMap: boolean) {
    this.isMapView = isMap;
    if (this.isMapView) {
      setTimeout(() => {
        this.initMap();
      }, 100);
    }
  }

  toggleFullscreen() {
    this.isFullscreen = !this.isFullscreen;
    setTimeout(() => {
      if (this.map) {
        this.map.invalidateSize();
      }
    }, 300);
  }

  toggleSelection(index: number) {
    const isCurrentlySelected = this.objectInfoList1[index].selected;

    // Deselect all
    this.objectInfoList1.forEach((item: any, i: number) => {
      if (item.selected) {
        item.selected = false;
        if (this.markers[i]) {
          if (item.multiLatLng) {
            this.markers[i].eachLayer((layer: any) => {
              if (layer instanceof L.Polyline && !(layer instanceof L.Marker)) {
                layer.setStyle({ color: '#2196f3' });
              }
            });
          } else {
            if (this.markers[i].dragging) {
              this.markers[i].dragging.disable();
            }
            this.markers[i].setIcon(this.getMarkerIcon(item));
            this.markers[i].setZIndexOffset(0);
          }
        }
      }
    });

    if (!isCurrentlySelected) {
      // Select the clicked one
      this.objectInfoList1[index].selected = true;
      if (this.markers[index]) {
        if (this.objectInfoList1[index].multiLatLng) {
          this.markers[index].eachLayer((layer: any) => {
            if (layer instanceof L.Polyline && !(layer instanceof L.Marker)) {
              layer.setStyle({ color: '#ff9800' });
            }
          });
          if (this.markers[index].bringToFront) {
            this.markers[index].bringToFront();
          }
        } else {
          if (this.markers[index].dragging) {
            this.markers[index].dragging.enable();
          }
          this.markers[index].setIcon(this.getMarkerIcon(this.objectInfoList1[index]));
          this.markers[index].setZIndexOffset(1000); // bring to front
        }
      }

      const item = this.objectInfoList1[index];
      if (item.multiLatLng) {
        if (item.area && item.area.length > 0) {
          const latLngs = item.area.map((p: any) => [p.lat, p.lng]);
          this.map.fitBounds(latLngs, { padding: [50, 50], duration: 1.5 });
        } else {
          this.toastr.info('Click on the map to add points for the line.', 'Location Missing');
        }
      } else {
        if (this.map && item.lat && item.lng) {
          // Zoom in to the selected location
          this.map.flyTo([item.lat, item.lng], 15, {
            duration: 1.5
          });
        } else if (!item.lat || !item.lng) {
          this.toastr.info('Click on the map to mark the location for this asset.', 'Location Missing');
        }
      }
    } else {
      // If unselecting, zoom out to fit all markers
      if (this.map) {
        const latLngs: any[] = [];
        this.objectInfoList1.forEach((item: any) => {
          if (item.multiLatLng) {
            if (item.area && item.area.length > 0) {
              item.area.forEach((p: any) => latLngs.push([p.lat, p.lng]));
            }
          } else {
            if (item.lat && item.lng) {
              latLngs.push([item.lat, item.lng]);
            }
          }
        });
        if (latLngs.length > 0) {
          this.map.fitBounds(latLngs, { padding: [50, 50], duration: 1.5 });
        }
      }
    }
  }

  private getMarkerIcon(item: any): any {
    const isSelected = item.selected;
    const borderColor = isSelected ? '#ff9800' : '#2196f3'; // Orange if selected, else Blue
    const iconClass = 'bi-geo-alt-fill';
    const iconSize = isSelected ? 45 : 30; // Bigger if selected
    const markerHtml = `
      <div style="
        position: relative;
        width: ${iconSize}px;
        height: ${iconSize}px;
        background: ${borderColor};
        border: 2px solid white;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-size: ${isSelected ? 22 : 16}px;
        box-shadow: 0 4px 10px rgba(0,0,0,0.4);
        transition: all 0.3s ease;
      ">
        <i class="bi ${iconClass}"></i>
      </div>
    `;

    return L.divIcon({
      className: 'custom-leaflet-marker',
      html: markerHtml,
      iconAnchor: [iconSize / 2, iconSize / 2],
      popupAnchor: [0, -(iconSize / 2) - 8] // Adjusted slightly higher to avoid overlap
    });
  }

  private getAngle(p1: [number, number], p2: [number, number]): number {
    if (!this.map) return 0;
    const p1Point = this.map.latLngToLayerPoint(L.latLng(p1[0], p1[1]));
    const p2Point = this.map.latLngToLayerPoint(L.latLng(p2[0], p2[1]));
    const dy = p2Point.y - p1Point.y;
    const dx = p2Point.x - p1Point.x;
    return Math.atan2(dy, dx) * 180 / Math.PI;
  }

  private getArrowIcon(color: string, rotation: number): any {
    const markerHtml = `
      <div style="
        width: 24px;
        height: 24px;
        color: ${color};
        font-size: 24px;
        line-height: 1;
        transform: rotate(${rotation}deg);
        display: flex;
        align-items: center;
        justify-content: center;
        text-shadow: 0px 2px 4px rgba(0,0,0,0.5);
      ">
        <i class="bi bi-arrow-right-circle-fill" style="margin: 0; padding: 0;"></i>
      </div>
    `;

    return L.divIcon({
      className: 'custom-arrow-marker',
      html: markerHtml,
      iconSize: [24, 24],
      iconAnchor: [12, 12],
      popupAnchor: [0, -12]
    });
  }

  initMap() {
    if (this.map) {
      this.map.remove();
    }

    this.map = L.map('map', {
      center: this.defaultCenter,
      zoom: this.defaultZoom
    });

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; OpenStreetMap contributors'
    }).addTo(this.map);

    this.drawControl = new L.Control.Draw({
      draw: {
        polyline: {
          shapeOptions: {
            color: '#ff9800',
            weight: 5
          }
        },
        polygon: false,
        rectangle: false,
        circle: false,
        marker: false,
        circlemarker: false
      },
      edit: false
    });
    this.map.addControl(this.drawControl);

    this.map.on(L.Draw.Event.CREATED, (e: any) => {
      const type = e.layerType,
        layer = e.layer;

      if (type === 'polyline') {
        const selectedIndex = this.objectInfoList1.findIndex((item: any) => item.selected);
        if (selectedIndex !== -1) {
          const item = this.objectInfoList1[selectedIndex];
          if (item.multiLatLng) {
            const latlngs = layer.getLatLngs();
            item.area = latlngs.map((l: any) => ({ lat: l.lat, lng: l.lng }));
            if (item.area.length > 0) {
              item.lat = item.area[0].lat;
              item.lng = item.area[0].lng;
            }

            if (this.markers[selectedIndex]) {
              // Complete re-render for this item to properly update arrows and polyline
              this.map.removeLayer(this.markers[selectedIndex]);

              const points = item.area.map((p: any) => [p.lat, p.lng]);
              const polyline = L.polyline(points, { color: '#ff9800', weight: 5 });
              const groupLayers: any[] = [polyline];

              if (points.length >= 2) {
                for (let i = 0; i < points.length; i++) {
                  let angle = 0;
                  if (i < points.length - 1) {
                    angle = this.getAngle(points[i], points[i + 1]);
                  } else {
                    angle = this.getAngle(points[i - 1], points[i]);
                  }
                  let color = item.selected ? '#ff9800' : '#2196f3';

                  groupLayers.push(L.marker(points[i], { icon: this.getArrowIcon(color, angle), interactive: false }));
                }
              }

              const group = L.featureGroup(groupLayers).addTo(this.map);
              if (item.givenName) {
                group.bindPopup(`<div style="font-size: 15px; font-weight: 600;">${item.givenName}</div>`, { closeButton: false });
              }
              this.markers[selectedIndex] = group;

            } else {
              const points = item.area.map((p: any) => [p.lat, p.lng]);
              const polyline = L.polyline(points, { color: '#ff9800', weight: 5 });
              const groupLayers: any[] = [polyline];

              if (points.length >= 2) {
                for (let i = 0; i < points.length; i++) {
                  let angle = 0;
                  if (i < points.length - 1) {
                    angle = this.getAngle(points[i], points[i + 1]);
                  } else {
                    angle = this.getAngle(points[i - 1], points[i]);
                  }

                  let color = item.selected ? '#ff9800' : '#2196f3';

                  groupLayers.push(L.marker(points[i], { icon: this.getArrowIcon(color, angle), interactive: false }));
                }
              }

              const group = L.featureGroup(groupLayers).addTo(this.map);

              if (item.givenName) {
                group.bindPopup(`<div style="font-size: 15px; font-weight: 600;">${item.givenName}</div>`, { closeButton: false });
              }
              this.markers[selectedIndex] = group;
            }
          } else {
            this.toastr.warning('Please select a multi-location asset to draw a line.');
          }
        } else {
          this.toastr.warning('Please select an asset from the list first.');
        }
      }
    });

    if (this.objectInfoList1 && this.objectInfoList1.length > 0) {
      const latLngs: any[] = [];
      this.markers = [];

      this.objectInfoList1.forEach((item: any, index: number) => {
        if (item.multiLatLng) {
          if (item.area && item.area.length > 0) {
            const points = item.area.map((p: any) => [p.lat, p.lng]);
            latLngs.push(...points);

            const polylineColor = item.selected ? '#ff9800' : '#2196f3';
            const polyline = L.polyline(points, { color: polylineColor, weight: 5 });
            const groupLayers: any[] = [polyline];

            if (points.length >= 2) {
              for (let i = 0; i < points.length; i++) {
                let angle = 0;
                if (i < points.length - 1) {
                  angle = this.getAngle(points[i], points[i + 1]);
                } else {
                  angle = this.getAngle(points[i - 1], points[i]);
                }

                let color = item.selected ? '#ff9800' : '#2196f3';

                groupLayers.push(L.marker(points[i], { icon: this.getArrowIcon(color, angle), interactive: false }));
              }
            }

            const group = L.featureGroup(groupLayers).addTo(this.map);

            if (item.givenName) {
              group.bindPopup(`<div style="font-size: 15px; font-weight: 600;">${item.givenName}</div>`, { closeButton: false });
            }

            this.markers.push(group);
          } else {
            this.markers.push(null);
          }
        } else {
          if (item.lat && item.lng) {
            latLngs.push([item.lat, item.lng]);

            const customHtmlIcon = this.getMarkerIcon(item);

            const marker = L.marker([item.lat, item.lng], {
              icon: customHtmlIcon,
              draggable: !!item.selected
            }).addTo(this.map);

            marker.on('dragend', (event: any) => {
              const position = event.target.getLatLng();
              this.objectInfoList1[index].lat = position.lat;
              this.objectInfoList1[index].lng = position.lng;
            });

            if (item.givenName) {
              marker.bindPopup(`<div style="font-size: 15px; font-weight: 600;">${item.givenName}</div>`, { closeButton: false });
            }

            this.markers.push(marker);
          } else {
            this.markers.push(null);
          }
        }
      });

      if (latLngs.length > 0) {
        const bounds = L.latLngBounds(latLngs);
        this.map.fitBounds(bounds, { padding: [40, 40], maxZoom: 12 });
        this.map.invalidateSize();
      }

      this.map.on('click', (e: any) => {
        const selectedIndex = this.objectInfoList1.findIndex((item: any) => item.selected);
        if (selectedIndex !== -1) {
          const item = this.objectInfoList1[selectedIndex];
          if (!item.multiLatLng) {
            if (!item.lat || !item.lng) {
              item.lat = e.latlng.lat;
              item.lng = e.latlng.lng;

              const customHtmlIcon = this.getMarkerIcon(item);

              const marker = L.marker([item.lat, item.lng], {
                icon: customHtmlIcon,
                draggable: true
              }).addTo(this.map);

              marker.on('dragend', (event: any) => {
                const position = event.target.getLatLng();
                this.objectInfoList1[selectedIndex].lat = position.lat;
                this.objectInfoList1[selectedIndex].lng = position.lng;
              });

              if (item.givenName) {
                marker.bindPopup(`<div style="font-size: 15px; font-weight: 600;">${item.givenName}</div>`, { closeButton: false });
              }

              this.markers[selectedIndex] = marker;
              this.markers[selectedIndex].setZIndexOffset(1000);
            }
          }
        }
      });
    }
  }

}